
export default {
  name: 'KrProduct',
  props: {
    clientData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cards: [
        {
          title: this.$t('kr.product.card1.title'),
          slug: 'international-express',
          icon: require('@/assets/img/home/kr-card-top-icon-1.png'),
          iconWhite: require('@/assets/img/home/kr-card-top-icon-white-1.png'),
          subTitle: this.$t('kr.product.card1.subTitle'),
          descText: this.$t('kr.product.card1.descText'),
          grayImg: require('@/assets/img/home/kr-card-bottom-1.png'),
          redImg: require('@/assets/img/home/kr-red-card-right-bottom-1.png'),
        },
        {
          title: this.$t('kr.product.card2.title'),
          slug: 'ecommerce',
          icon: require('@/assets/img/home/kr-card-top-icon-2.png'),
          iconWhite: require('@/assets/img/home/kr-card-top-icon-white-2.png'),
          subTitle: this.$t('kr.product.card2.subTitle'),
          descText: this.$t('kr.product.card2.descText'),
          grayImg: require('@/assets/img/home/kr-card-bottom-2.png'),
          redImg: require('@/assets/img/home/kr-red-card-right-bottom-2.png'),
        },
        {
          title: this.$t('kr.product.card3.title'),
          slug: 'supply-chain',
          icon: require('@/assets/img/home/kr-card-top-icon-3.png'),
          iconWhite: require('@/assets/img/home/kr-card-top-icon-white-3.png'),
          subTitle: this.$t('kr.product.card3.subTitle'),
          descText: this.$t('kr.product.card3.descText'),
          grayImg: require('@/assets/img/home/kr-card-bottom-3.png'),
          redImg: require('@/assets/img/home/kr-red-card-right-bottom-3.png'),
        },
        {
          title: this.$t('kr.product.card4.title'),
          slug: 'finance',
          icon: require('@/assets/img/home/kr-card-top-icon-4.png'),
          iconWhite: require('@/assets/img/home/kr-card-top-icon-white-4.png'),
          subTitle: this.$t('kr.product.card4.subTitle'),
          descText: this.$t('kr.product.card4.descText'),
          grayImg: require('@/assets/img/home/kr-card-bottom-4.png'),
          redImg: require('@/assets/img/home/kr-red-card-right-bottom-4.png'),
        },
        {
          title: this.$t('kr.product.card5.title'),
          slug: 'agency',
          icon: require('@/assets/img/home/kr-card-top-icon-5.png'),
          iconWhite: require('@/assets/img/home/kr-card-top-icon-white-5.png'),
          subTitle: this.$t('kr.product.card5.subTitle'),
          descText: this.$t('kr.product.card5.descText'),
          grayImg: require('@/assets/img/home/kr-card-bottom-5.png'),
          redImg: require('@/assets/img/home/kr-red-card-right-bottom-5.png'),
        },
      ],
      activeIndex: 0,
    }
  },
  methods: {
    switchCard(index) {
      this.activeIndex = index
    },
    goDetail(slug) {
      this.$router.push({
        name: 'site-lang-productDetail',
        params: {
          site: this.$route.params.site,
          lang: this.$route.params.lang,
        },
        query: { slug },
      })
    },
    handleClick() {
      const { site, lang } = this.$route.params;
      this.$router.push({ path: `/${site}/${lang}/cooperation` });
    }
  },
}
